"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSymbol = exports.SYMBOL_MAP = exports.getLabel = exports.LABEL_MAP = exports.Compound = exports.TenthMicrosiemensPerCentimeter = exports.MicrosiemensPerCentimeter = exports.SignedPercentage = exports.Percentage = exports.KilopascalGauge = exports.DecibelMilliwatts = exports.PoundsPerSquareInch = exports.PartsPerMillion = exports.NAMESPACE = void 0;
const effect_1 = require("effect");
exports.NAMESPACE = 'Unit.Compound';
exports.PartsPerMillion = effect_1.Schema.TaggedStruct('PartsPerMillion', {
    amount: effect_1.Schema.Number,
}).annotations({
    identifier: `${exports.NAMESPACE}.PartsPerMillion`,
    description: 'A unit of proportion equal to one part in one million',
    documentation: 'https://en.wikipedia.org/wiki/Parts-per_notation',
});
exports.PoundsPerSquareInch = effect_1.Schema.TaggedStruct('PoundsPerSquareInch', {
    amount: effect_1.Schema.Number,
}).annotations({
    identifier: `${exports.NAMESPACE}.PoundsPerSquareInch`,
    description: 'A unit of pressure equal to one pound-force applied to one square inch',
    documentation: 'https://en.wikipedia.org/wiki/Pound_per_square_inch',
});
exports.DecibelMilliwatts = effect_1.Schema.TaggedStruct('DecibelMilliwatts', {
    amount: effect_1.Schema.Number,
}).annotations({
    identifier: `${exports.NAMESPACE}.DecibelMilliwatts`,
    documentation: 'https://en.wikipedia.org/wiki/DBm',
});
exports.KilopascalGauge = effect_1.Schema.TaggedStruct('KilopascalGauge', {
    amount: effect_1.Schema.Number,
}).annotations({
    identifier: `${exports.NAMESPACE}.KilopascalGauge`,
    description: 'Pressure in kilopascals relative to atmospheric pressure, so it can be negative',
    documentation: 'https://en.wikipedia.org/wiki/Pressure_measurement#Absolute,_gauge_and_differential_pressures',
});
exports.Percentage = effect_1.Schema.TaggedStruct('Percentage', {
    amount: effect_1.Schema.NonNegative,
}).annotations({
    identifier: `${exports.NAMESPACE}.Percentage`,
});
exports.SignedPercentage = effect_1.Schema.TaggedStruct('SignedPercentage', {
    amount: effect_1.Schema.Number,
}).annotations({
    identifier: `${exports.NAMESPACE}.SignedPercentage`,
    description: 'A percentage that can be negative, e.g. a correction factor',
});
exports.MicrosiemensPerCentimeter = effect_1.Schema.TaggedStruct('MicrosiemensPerCentimeter', {
    amount: effect_1.Schema.NonNegative,
}).annotations({
    identifier: `${exports.NAMESPACE}.MicrosiemensPerCentimeter`,
});
exports.TenthMicrosiemensPerCentimeter = effect_1.Schema.TaggedStruct('TenthMicrosiemensPerCentimeter', {
    amount: effect_1.Schema.NonNegative,
}).annotations({
    identifier: `${exports.NAMESPACE}.TenthMicrosiemensPerCentimeter`,
});
exports.Compound = effect_1.Schema.Union(exports.PartsPerMillion, exports.PoundsPerSquareInch, exports.DecibelMilliwatts, exports.KilopascalGauge, exports.Percentage, exports.SignedPercentage, exports.MicrosiemensPerCentimeter, exports.TenthMicrosiemensPerCentimeter).annotations({
    identifier: `${exports.NAMESPACE}.Compound`,
});
exports.LABEL_MAP = {
    PartsPerMillion: 'parts per million',
    PoundsPerSquareInch: 'pounds per square inch',
    DecibelMilliwatts: 'decibel-milliwatts',
    KilopascalGauge: 'kilopascal gauge',
    Percentage: 'percent',
    SignedPercentage: 'percent',
    MicrosiemensPerCentimeter: 'microsiemens per centimeter',
    TenthMicrosiemensPerCentimeter: '⅒ microsiemens per centimeter',
};
/**
 * Retrieves the label corresponding to a given {@link Compound}-tag
 */
const getLabel = (tag) => exports.LABEL_MAP[tag];
exports.getLabel = getLabel;
exports.SYMBOL_MAP = {
    PartsPerMillion: 'ppm',
    PoundsPerSquareInch: 'psi',
    DecibelMilliwatts: 'dBm',
    KilopascalGauge: 'kPa',
    Percentage: '%',
    SignedPercentage: '%',
    MicrosiemensPerCentimeter: 'μS/cm',
    TenthMicrosiemensPerCentimeter: '⅒μS/cm',
};
/**
 * Retrieves the symbol corresponding to a given {@link Compound}-tag
 */
const getSymbol = (tag) => exports.SYMBOL_MAP[tag];
exports.getSymbol = getSymbol;
//# sourceMappingURL=compound.js.map